import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { CancelReason } from "@nestcoinco/hyper-api-gateway-api-client";

import { QUERY_KEYS } from "../constants";
import { handleCancelTournamentEntry } from "../../api-clients/tournamentsClient";
import { showSuccessToast } from "../../utils/show-toast";

function useCancelTournamentEntryMutation({
  entryId,
  redirectUrl,
  reason,
}: {
  entryId: string;
  redirectUrl?: string;
  reason?: CancelReason;
}) {
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationKey: [QUERY_KEYS.TOURNAMENT.CANCEL_ENTRY],
    mutationFn: () => handleCancelTournamentEntry(entryId, reason),
  });

  const cancelEntry = () => {
    if (!entryId) return;
    mutation.mutate();
  };

  useEffect(() => {
    if (!mutation.isSuccess) return;
    showSuccessToast("Game cancelled..");
    if (redirectUrl) navigate(redirectUrl);
  }, [mutation.isSuccess, navigate, redirectUrl]);

  return { mutation, cancelEntry };
}

export default useCancelTournamentEntryMutation;
